<template>
  <div class="container-fluid">
    <template v-if="product">
      <div class="d-flex align-items-center">
        <back-button class="mr-2" to="/settings/recipes/products"/>
        <h1>{{ product.name }}</h1>
      </div>
      <div class="table-full-width">
        <table class="table">
          <thead>
          <tr>
            <th>Ингредиент</th>
            <th>Количество</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="component in product.components">
            <template v-if="component.component">
              <td>{{ component.component.name }}</td>
              <td>{{ component.amount }} <span class="text-muted">{{ component.component.measure }}</span></td>
            </template>
            <td colspan="2" v-else>
              <small><samp
                class="text-muted"
                data-title="Некорректная ссылка"
                data-toggle="tooltip"
                data-placement="right"
              >
                {{component.component_id}}
              </samp></small>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    metaInfo () {
      const productName = this.product ? this.product.name : ''
      return {title: `Рецептура ${productName}`}
    },
    data () {
      return {}
    },
    asyncComputed: {
      product () {
        return api.get(`products/${this.$route.params.id}`)
          .then(({data}) => data.data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/recipes/products/_id.vue